import { fakeData } from "./FakeData";

const defaultPageNumber = 1;
const defaultPageSize = 25;

const ProductData = fakeData;

const getProducts = async (
  pageNumber = null,
  pageSize = null,
  sorter = null,
  filter = null
) => {
  try {
    const size = pageSize ?? defaultPageSize;
    const num = pageNumber ?? defaultPageNumber;

    let result = ProductData.slice();
    if (filter) {
      if (filter["category"])
        result = result.filter((o) => filter.category === o.category);
    }

    const HeaderTotal = result.length;
    const temp = result.slice(size * (num - 1), size * num);

    const response = {
      data: temp,
    };

    return { products: response.data, total: Number(HeaderTotal) };
  } catch (error) {
    return { products: [], total: 0 };
  }
};

const getProductById = (id) => {
  try {
    let temp = ProductData.find((o) => o.id == id);

    if (!temp) throw Error("target is empty");

    return temp;
  } catch (error) {
    return { error: true };
  }
};

const getUniqueTag = () => {
  const tagsList = ProductData.map((o) => o.tags);

  let uniqueTagsList = [];

  for (const item of tagsList) {
    const temp = item.split(" ");

    uniqueTagsList = [...uniqueTagsList, ...temp];
  }

  // @ts-ignore
  return [...new Set(uniqueTagsList)];
};

const getUniqueCategory = () => {
  const categoryList = ProductData.map((o) => o.category);

  // @ts-ignore
  return [...new Set(categoryList)];
};

export { getProducts, getProductById, getUniqueTag, getUniqueCategory };
